import { render } from "./H1.vue?vue&type=template&id=ae54d9dc&scoped=true"
const script = {}

import "./H1.vue?vue&type=style&index=0&id=ae54d9dc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae54d9dc"]])

export default __exports__